import { CSSProperties } from 'react';

interface IBadge {
    text: string,
    bgColor?: string,
    style?: CSSProperties,
}

const Badge = (props: IBadge) => {
    return (
        <span
            className={ `flex items-center justify-center ml-4 text-xs py-1 px-2 rounded whitespace-nowrap ${ props.bgColor ? props.bgColor : 'bg-blue-800' }` }
            style={ props.style }
        >{ props.text }</span>
    )
};

export default Badge;